import React from "react";
import PropTypes from "prop-types";
import BlanketDetailedInformationBase from "./BlanketDetailedInformationBase";
import { BLANKET_DETAILED_INFO_CONFIG } from "./blanketDetailedInformationConfig";

export default function DetailedInformation(props) {
  return (
    <BlanketDetailedInformationBase
      config={BLANKET_DETAILED_INFO_CONFIG.creation}
      {...props}
    />
  );
}

DetailedInformation.propTypes = {
  control: PropTypes.object.isRequired,
  errors: PropTypes.object,
  watch: PropTypes.func.isRequired,
};
